import { Client } from "@/Common/Api/Client";
import { ClientResponse } from "@/Common/Api/ClientResponse";
import { PortalLinkedItemType } from "@/Common/Models/Portal/Enums/PortalLinkedItemType";
import { SharedItem } from "@/Common/Models/Portal/SharedItem/SharedItem";
import * as ServerOperations from "@/Common/Operations/operations.server";

async function sendDocumentToPortal(objectId: string, sharedItem: SharedItem, includeLinkedItem: boolean): Promise<ClientResponse> {
    let requestData = {
        ObjectId: objectId,
        SharedItemType: sharedItem.SharedItemType,
        Subject: sharedItem.Subject,
        PatientContactId: sharedItem.PatientContactId,
        IncludeLinkedItem: includeLinkedItem,
        Messages: sharedItem.Messages,
        SharedItemId: sharedItem.SharedItemId,
        LabMessageDTO: null,
        CanPatientReplyWithMessage: sharedItem.CanPatientReplyWithMessage
    };

    return await Client.postAsync(ServerOperations.Server.Myle_Patient_Portal_SyncSharedItem, requestData);
}

async function revokPortalDocument(sharedItemId: string, sharedItemMessages: number[], userId: string, sharedItemType: PortalLinkedItemType, billId: string, includeLinkedItem: boolean): Promise<ClientResponse> {
    let requestData =
        {
            SharedItemId: sharedItemId,
            SharedItemMessageIds: sharedItemMessages,
            UserId: userId,
            IncludeLinkedItem: includeLinkedItem,
            SharedItemType: sharedItemType,
            ObjectId: billId
        };

    return await Client.postAsync(ServerOperations.Server.Myle_Patient_Portal_RevokeSharedItem, requestData);
}

export { revokPortalDocument, sendDocumentToPortal };
